import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=c91f6bfc&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
import style0 from "./Services.vue?vue&type=style&index=0&id=c91f6bfc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91f6bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c91f6bfc')) {
      api.createRecord('c91f6bfc', component.options)
    } else {
      api.reload('c91f6bfc', component.options)
    }
    module.hot.accept("./Services.vue?vue&type=template&id=c91f6bfc&scoped=true", function () {
      api.rerender('c91f6bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Services.vue"
export default component.exports